import styled, { css } from 'styled-components';
import color from '@deprecated-ui/_style/color';
import Text from '@deprecated-ui/common/Text';
import Table from '@deprecated-ui/calendar/Table';

const Th = styled(Text).attrs({ family: 'bold', weight: 700 })``;
const CustomTable = styled(Table)`
  font-family: var(--regular-font);

  .today {
    & .today-column {
      font-family: var(--bold-font);
      font-weight: 700;
    }
  }
  .today td {
    background-color: #d5ead7;
  }

  .yesterday {
    color: ${color.darkGray};
  }

  .text--bold {
    font-family: var(--bold-font);
    font-weight: 700;
  }

  ${(props) =>
    // @ts-expect-error
    props?.isIpo &&
    css`
      @media screen and (max-width: 720px) {
        .ant-table-cell-fix-left-last {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    `}
`;

const SubTitle = styled(Text).attrs({ padding: '15px 10px', family: 'bold' })`
  border-bottom: 1px solid ${color.gainsboro};
  border-top: 1px solid ${color.gainsboro};

  :first-child {
    border-top: 0;
  }
`;

const EmptyCalendarWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 990px;
  background-color: ${color.light};
  border: 1px solid ${color.gainsboro};
  height: 500px;
`;

export { Th, CustomTable, SubTitle, EmptyCalendarWrapper };
